const StateField = (props: any) => {
    return (
        <>
            {
                props.idMood.Nombre === 'Motivado' && (
                    <div className="badge-success">
                        <span>{props.idMood.Nombre}</span>
                    </div>
                )
            }
            {
                props.idMood.Nombre === 'Productivo' && (
                    <div className="badge-secondary">
                        <span>{props.idMood.Nombre}</span>
                    </div>
                )
            }
            {
                props.idMood.Nombre === 'Aburrido' && (
                    <div className="badge-info">
                        <span>{props.idMood.Nombre}</span>
                    </div>
                )
            }
            {
                props.idMood.Nombre === 'Presionado' && (
                    <div className="badge-warning">
                        <span>{props.idMood.Nombre}</span>
                    </div>
                )
            }
            {
                props.idMood.Nombre === 'Enfadado' && (
                    <div className="badge-danger">
                        <span>{props.idMood.Nombre}</span>
                    </div>
                )
            }
        </>
    )
}
export default StateField;